import SwitchSelectField from 'src/components/fields/SwitchSelectField/SwitchSelectField';

export default SwitchSelectField;
